import { H2, P2 } from '../../../styles/FontStyles';
import { Main, Section5Wrapper } from '../Home.styled';
import { lightTheme } from '../../../styles/GlobalStyles';
import { Div, Img } from '../../../styles/Styles';
import { AnimatedDiv } from 'components/Animation/Animation';
import { Button } from 'components/Button/Button';
import { backofficeLink } from 'helpers/helpers';
import { ArrowButtonWhiteIcon } from 'styles';
import image5 from '../../../assets/images/sec5Image.png';

export const Section5 = () => {
  const ButtonComponent = () => {
    return (
      <a
        href={backofficeLink + '/login'}
        target='_blank'
        rel='noopener noreferrer'
      >
        <Button $negative $width='100%' $height='50px'>
          Get Started <ArrowButtonWhiteIcon />
        </Button>
      </a>
    );
  };

  return (
    <Section5Wrapper id='section5'>
      <Main>
        <AnimatedDiv $flex $center $columnSM $gap='150px' $gapSM='50px'>
          <Div $width='50%' $widthSM='100%'>
            <H2 mb='30' centerSM color={lightTheme.white}>
              About United One
            </H2>
            <P2 mb='40' color={lightTheme.white}>
              <b>United One</b> is the world’s premier AI-enhanced education and
              empowerment platform. It fuses cutting-edge AI tools, expert
              training, and a global community
              <br />
              <br />
              We transform lives by arming people with personal, financial, and
              tech skills to dominate the digital economy. We unite ambition,
              innovation, and opportunity in one unstoppable ecosystem
            </P2>
            <Div $desktop>
              <ButtonComponent />
            </Div>
          </Div>
          <Div $width='50%' $widthSM='100%'>
            <Img src={image5} width='100%' alt='section5' />
            <Div $mobile $mt='50px'>
              <ButtonComponent />
            </Div>
          </Div>
        </AnimatedDiv>
      </Main>
    </Section5Wrapper>
  );
};
